import React from "react";
import InvalidPage from "../common-components/InvalidPage";
import { useSelector } from "react-redux";

const InvalidOrganization = () => {
  const { organizationId } = useSelector((state) => state.info);
  return (
    <InvalidPage
      image={"/assets/images/invalid-pages/invalid-organization.svg"}
      title={`Oops! Organization ID "${organizationId}" wasn’t found`}
      subtitle="Please contact your system administrator"
    />
  );
};

export default InvalidOrganization;
